module.exports = __webpack_public_path__ + "Release.7d34d1b7818bdc4de23db73c29ea1b98.hashedasset.svg";